// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: relative;
  padding: 20px;
}
@media screen and (max-width: 800px) {
  .container {
    padding: 0;
  }
}
.container image-cropper {
  height: 100%;
  max-height: 300px !important;
  width: 100%;
  max-width: 1140px;
}
.container .close-icon {
  position: absolute;
  top: 8px;
  right: 5px;
  z-index: 5;
}
.container .close-icon:hover {
  cursor: pointer;
}
.container .all-cont {
  display: block !important;
  width: 100%;
}
.container .middle-container {
  min-height: 200px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.container .middle-container .name-error-info {
  font-size: 1.2rem;
  color: #f44336;
  top: -15px;
  position: relative;
}
.container .middle-container .form-label {
  font-size: 1.2rem;
  font-weight: 400;
  opacity: 0.6;
  margin-top: 20px;
}
.container .middle-container .error-info {
  font-size: 0.9rem;
  margin-top: -5px !important;
}
.container .img-data {
  margin-top: 10px;
  font-size: 14px;
  flex-basis: calc(100% - 100px);
}
@media screen and (max-width: 800px) {
  .container .img-data {
    padding: 0;
  }
}
.container .img-data .img-scale {
  position: absolute;
  right: 0;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media screen and (max-width: 800px) {
  .container .img-data .img-scale {
    justify-content: flex-end;
    margin: 10px 10px 10px 0;
    position: relative;
  }
  .container .img-data .img-scale .btn-grey {
    margin-right: 10px;
    margin-top: 10px;
    white-space: nowrap;
  }
  .container .img-data .img-scale span {
    display: block;
    width: 100%;
  }
}
@media screen and (max-width: 600px) {
  .container .img-data .img-scale {
    display: block;
  }
}
.container .img-data .img-res {
  margin-bottom: 10px;
}
@media screen and (max-width: 800px) {
  .container .img-data .img-res {
    font-size: 13px;
  }
}
.container .img-data .crop-res {
  margin-bottom: 4px;
  z-index: 5;
  position: relative;
}
@media screen and (max-width: 800px) {
  .container .img-data .crop-res {
    font-size: 13px;
  }
}
.container .img-data .crop-res .crop-res-inputs {
  display: inline-block;
}
@media screen and (max-width: 800px) {
  .container .img-data .crop-res .crop-res-inputs {
    display: block;
    margin-top: 10px;
  }
  .container .img-data .crop-res .crop-res-inputs #widthInput {
    margin-left: 0;
  }
}
.container .img-data .crop-res input {
  margin: 0 3px;
  width: 65px;
  text-align: right;
  padding-right: 5px;
}
.container .img-data .crop-res input#widthInput {
  margin-left: 10px;
}
.container .img-data .error-msg {
  position: relative;
  width: 100%;
  text-align: center;
}
.container .img-data .error-msg .error-info {
  color: red;
  font-weight: 700;
  font-size: 16px;
}
@media screen and (max-width: 800px) {
  .container .img-data .error-msg .error-info {
    font-size: 14px;
    text-align: left;
  }
}
.container .bottom-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
}
.container .bottom-container .bottom-right ul {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}
.container .bottom-container .bottom-right ul .btn-grey {
  background-color: #f6f6f6;
  color: #000;
  border: 1px solid #dedede;
  border-radius: 4px;
}
.container .bottom-container .bottom-right ul .btn-black {
  background-color: #000;
  color: white;
  border-radius: 4px;
  padding: 8px 25px;
  font-size: 1.4rem;
}
.container .bottom-container .bottom-right ul .btn:disabled {
  opacity: 0.5 !important;
}
.container .bottom-container .bottom-right ul .btn:hover {
  opacity: 0.8;
}

.btn-container {
  display: flex;
  flex-direction: row-reverse;
  padding-right: 25px;
}
.btn-container button {
  min-width: 120px;
  border-radius: 5px;
  font-size: 14px;
}

.btn-grey {
  background: #dadada;
  color: #000000;
  font-weight: 400;
  padding: 8px 25px;
}
@media screen and (max-width: 800px) {
  .btn-grey {
    padding: 6px 25px;
    font-size: 13px;
  }
}

button:hover {
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
